/**
 * This service is to convert stuffs from server-side, e.g: convert server object blob and
 *  convert it back to post, service helper is a interface to filter server data to
 *  integration data(POS/fulfilment)
 * @param _ lodash
 * @returns {*}
 */
function integrationHelperService(integrationConstant, _, domainNamesConstant) {
    return {
        // TODO I need to review these 2 method, replicate code
        // convertBackToDomainObjectOutlet have to make another function very similar to the merchant, need more tests
        // and remove all duplication
        convertBackToDomainObjectOutlet(flattenData) {
            const constantMap = domainNamesConstant.MAP_FIELD_NAME;
            // save only the useMerchantSettings if it's selected
            if (flattenData.isUseMerchantSettings) {
                return {'useMerchantSettings': true};
            }
            const reduceRootKeys = (acc, key) => {
                // TODO nested ifs
                if (!constantMap[key].transient) {
                    // constantMap[key].both back-end bad design need to add posType to the root
                    if (!constantMap[key].outletPosProsKey) {
                        if (acc[constantMap[key].betterName]) {
                            // for outlet(domain object) the attributes have different name with the same purpose
                            // for the front-end it just keep one name
                            acc[constantMap[key].betterName] = [acc[constantMap[key].betterName], key];
                        } else {
                            acc[constantMap[key].betterName] = key;
                        }
                    }
                }
                return acc;
            };
            const keysFromConstantMap = Object.keys(constantMap);
            // map(key, value) betterName(key) originalName(value)
            const mapBetterNameRootToOriginalName = keysFromConstantMap.reduce(reduceRootKeys, {});

            const reduceMerchantPropsKeys = (acc, key) => {
                if (!constantMap[key].transient && constantMap[key].outletPosProsKey) {
                    acc[constantMap[key].betterName] = key;
                }
                return acc;
            };

            // map(key, value) betterName(key) originalName(value)
            const mapBetterNameMerchantPropsToOriginalName = keysFromConstantMap.reduce(reduceMerchantPropsKeys, {});

            const reduceConvertFlattenToServerData = (acc, key) => {
                // key from flatten is in the root or in the merchantPros
                const originalRootName = mapBetterNameRootToOriginalName[key];
                const originalMerPropName = mapBetterNameMerchantPropsToOriginalName[key];
                if (originalRootName) {
                    // duplicate names
                    if (Array.isArray(originalRootName)) {
                        originalRootName.forEach(keyItem => {
                            // add the same value to key and overwrite key
                            acc[keyItem] = flattenData[key];
                        });
                    } else {
                        acc[originalRootName] = flattenData[key];
                    }
                }
                // it could be in both(root and namespace, bad domain object design)
                if (flattenData.integration === integrationConstant.INTEGRATION_TYPE.POS.value
                    && originalMerPropName) {
                    if (!acc.posProperties) {
                        acc.posProperties = {};
                    }
                    acc.posProperties[originalMerPropName] = flattenData[key];
                }
                return acc;
            };
            // flattenData has betterName as keys
            const keysFromFlattenData = Object.keys(flattenData);
            return keysFromFlattenData.reduce(reduceConvertFlattenToServerData, {});
        },
        // also get confusing, split outlet from merchant ?
        convertBackToDomainObject(flattenData, location) {
            const constantMap = domainNamesConstant.MAP_FIELD_NAME;

            // map(key, value) betterName(key) originalName(value)
            const rootMapBetterNameOriginalName =
                Object.keys(constantMap)
                    .filter( key => {
                        return !constantMap[key].transient &&
                            !constantMap[key].merchantPosPropKey &&
                            !constantMap[key].isOutlet
                    }).reduce( (acc, key) => {
                        acc[constantMap[key].betterName] = key;
                        return acc;
                    }, {});

            // posProperties map(key, value) betterName(key) originalName(value)
            const posPropBetterNameOriginalName =
                Object.keys(constantMap)
                    .filter( key => constantMap[key].merchantPosPropKey && !constantMap[key].transient)
                    .reduce( (acc, key) => {
                        acc[constantMap[key].betterName] = key;
                        return acc;
                    }, {});

            const reduceConvertFlattenToServerData = (acc, key) => {
                // key from flatten is in the root or in the merchantPros
                const originalRootName = rootMapBetterNameOriginalName[key];
                const originalMerPropName = posPropBetterNameOriginalName[key];
                if (originalRootName) {
                    // duplicate names
                    acc[originalRootName] = flattenData[key];
                }
                // it could be in both(root and namespace, bad domain object design)
                if (originalMerPropName) {
                    if(location === integrationConstant.LOCATION.merchantAdmin.label) {
                        if (!acc.posPropertiesCommand) {
                            acc.posPropertiesCommand = {};
                        }
                        acc.posPropertiesCommand[originalMerPropName] = flattenData[key];
                    } else {
                        // merchant creation still calling merchantUnrest endpoint
                        if (!acc.merchantPosProperties) {
                            acc.merchantPosProperties = {};
                        }
                        acc.merchantPosProperties[originalMerPropName] = flattenData[key];
                    }
                }
                return acc;
            };
            // flattenData has betterName as keys
            const keysFromFlattenData = Object.keys(flattenData);
            return keysFromFlattenData.reduce(reduceConvertFlattenToServerData, {});
        },
        convertServerDataToFlatten(data) {
            // get only what belongs to integration and also give better names.
            if (!data) {
                return {};
            }
            const posProperties = data.merchantPosProperties || data.posProperties || undefined;
            // bad-domain structure
            /* eslint fp/no-mutation:0 */
            let posType;
            if (posProperties && posProperties.posType) {
                posType = posProperties.posType;
            } else if (data.posType) {
                posType = data.posType;
            }

            const integration = posType ?
                integrationConstant.INTEGRATION_TYPE.POS.value :
                integrationConstant.INTEGRATION_TYPE.FULFILLMENT.value;

            const newData = _.merge({integration}, data);
            const matrixName = domainNamesConstant.MAP_FIELD_NAME;

            const getDefaultValue = (value, defaultValue) => value === undefined ? defaultValue : value;

            const reduceNewDomainWithBetterNames = (acc, key) => {
                const freshName = matrixName[key].betterName;

                if (key in newData) {
                    acc[freshName] = getDefaultValue(newData[key], matrixName[key].defaultValue);
                } else if (posProperties && key in posProperties) {
                    acc[freshName] = getDefaultValue(posProperties[key], matrixName[key].defaultValue);
                } else if (newData.options && (key in newData.options)) {
                    acc[freshName] = getDefaultValue(newData.options[key], matrixName[key].defaultValue);
                } else {
                    // TODO I'm adding undefined but it's better to add null, add null instead then filter ...
                    // TODO before post, but need to make same test before.
                    // add undefined instead of null and the request will ignore.
                    // if acc[freshName] already has a value because for outlet the attribute name are different
                    acc[freshName] = getDefaultValue(acc[freshName], matrixName[key].defaultValue);
                }
                return acc;
            };

            return Object.keys(matrixName)
                .reduce(reduceNewDomainWithBetterNames, {});
        },
        getServerNameFromConstant(flatName) {
            return Object
                .entries(domainNamesConstant.MAP_FIELD_NAME)
                .filter(([key, objectAttr]) => objectAttr.betterName === flatName)[0];
        },
        getBetterNameFromConstant(serverDomainName) {
            return domainNamesConstant
                .MAP_FIELD_NAME[serverDomainName]
                .betterName;
        }
    };
}
angular.module('qkr.integration.settings')
    .factory('integrationHelperService', integrationHelperService);



// WEBPACK FOOTER //
// ./src/integration-settings/services/integration.helper.service.js